import NoteLightBoxContainer from './NoteLightBoxContainer';

export default NoteLightBoxContainer;
